import { network } from 'services/network';
import { useMutation } from 'react-query';
import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

import { ISingleSmallCardResponse } from 'api/queries/getListFilteredCards.query';

const extractDelayDriverCsv = (params) => {
    return network
        .post('api/bo/extractDelayDriverCsv', {
            fileMetaDataId: params.fileMetaDataId,
            filter: { filters: params.filter },
        })
        .then((response) => {
            const blob = new Blob([response.data], {
                type: 'text/plain',
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = `${params.fileName}.csv`;
            a.click();

            return true;
        });
};

export const useMutationExtractDelayDriverCsv = () => {
    return useMutation<unknown, QueryError, IExtractDelayDriverCsvPayload>((params) => extractDelayDriverCsv(params));
};

interface IExtractDelayDriverCsvPayload {
    fileMetaDataId: number;
    fileName: string;
    filter: IFilter[] | undefined;
}

export interface ITopOverdueData {
    criticalityScore: number;
    float: null | number;
    taskVersionHashCode: string;
    plannedStartDate: number;
    plannedFinishDate: number;
    actualStartDate: number;
    actualFinishDate: number;
    numOfPredecessors: number;
    numOfSuccessors: number;
    projectWeekStart: number;
    projectWeekFinish: number;
    projectMonthStart: number;
    projectMonthFinish: number;
    activityId: string;
    parentName: string;
    grandParentName: string;
    plannedDuration: number;
    actualDuration: number;
    remainingDuration: number;
    completedDuration: number;
    activityType: string;
    activityName: string;
    overrunDays: number;
    overrunPercent: number;
    criticalPath: boolean;
    delayDriver: boolean;
    currentStartDate: number;
    currentFinishDate: number;
    baselineStartDate: number;
    baselineFinishDate: number;
    durationOverun: number;
    cardBoardViewResponse: ISingleSmallCardResponse;
}
